import React from 'react'

import CardHeader from './CardHeader'
import MyPieChart from './MyPieChart'
import TooltipGraficoPizza from './TooltipGraficoPizza'

export default function GraficoStatusContrato({
  portalCliente,
  handleAbrirMenuOpcoes,
  revelarOpcoesStatusContrato,
  menuElement,
  graficoStatusContrato,
  graficoStatusContratoMax,
  legendaStatusContrato,
  totalSimcards
}) {
  return (
    <div
      className="container-dashboard-fundo-3 fundo-cor-5"
      id="grafico-status-contrato"
    >
      <CardHeader
        titulo="Status do contrato"
        nomeOpcao="statusContrato"
        portalCliente={portalCliente}
        handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
      />

      <div className="grupo-dash-grafico-pizza-grande">
        {revelarOpcoesStatusContrato === true && (
          <div className="menu-opcoes-dashboard-fundo">{menuElement}</div>
        )}
        <div className="container-status-contrato">
          <div className="container-grafico-pizza-status-contrato">
            <div className="caixa-grafico-pizza-status-contrato">
              <MyPieChart
                key={JSON.stringify(graficoStatusContrato)}
                data={graficoStatusContrato}
                valorPercentual={graficoStatusContratoMax}
                MyTooltip={(props) => (
                  <TooltipGraficoPizza
                    {...props}
                    arrDados={graficoStatusContrato}
                    totalSimcards={totalSimcards}
                  />
                )}
              />
            </div>
          </div>
          <div className="container-legenda-status-contrato">
            {legendaStatusContrato}
          </div>
        </div>
      </div>
    </div>
  )
}
